// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "step-bwzVP";
var _3 = "text-1rLUF";
var _4 = "stepTitle__icon-e4vJU";
export { _1 as "__esModule", _2 as "step", _3 as "text", _4 as "stepTitle__icon" }
export default { "__esModule": _1, "step": _2, "text": _3, "stepTitle__icon": _4 }
